export enum MomentumLevel {
  Level0,
  Level1,
  Level2,
  Level3,
}

export const MomentumMultiplier: Record<MomentumLevel, number> = {
  [MomentumLevel.Level0]: 1,
  [MomentumLevel.Level1]: 1.5,
  [MomentumLevel.Level2]: 2,
  [MomentumLevel.Level3]: 3,
} as const
